import { http } from '@shared/api';
import type { AnalyticsRange, DashboardData } from '../model/types';

export const analyticsApi = {
  getDashboard: (range: AnalyticsRange) =>
    http.get('analytics/dashboard', { searchParams: { range } }).json<DashboardData>(),
};
